import { render, staticRenderFns } from "./HallEffectViz.vue?vue&type=template&id=0bc40d8c&scoped=true"
import script from "./HallEffectViz.vue?vue&type=script&lang=js"
export * from "./HallEffectViz.vue?vue&type=script&lang=js"
import style0 from "./HallEffectViz.vue?vue&type=style&index=0&id=0bc40d8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc40d8c",
  null
  
)

export default component.exports